/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { theme } from "@nordcloud/gnui";

export const StepCounter = styled.div`
  height: 2rem;
  min-width: 2rem;
  border-radius: ${theme.spacing.spacing01};
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${theme.color.background.ui04};
  margin-right: 10px;
  margin-bottom: ${theme.spacing.spacing05};
`;

export const StepWrapper = styled.div`
  padding-top: ${theme.spacing.spacing01};
  width: 100%;
  margin-bottom: ${theme.spacing.spacing05};

  & > *:last-child {
    margin-bottom: 0;
  }
`;

export const StyledListItem = styled.li`
  padding: ${theme.spacing.spacing02} ${theme.spacing.spacing02}
    ${theme.spacing.spacing02} ${theme.spacing.spacing06};
  border-radius: ${theme.radius.md};
  transition: ${theme.transition};
  text-indent: -1.4em;
  span {
    min-width: 1.5rem;
    text-align: right;
  }

  button {
    transition: ${theme.transition};
    opacity: 0;
  }

  &:hover {
    background: ${theme.color.background.ui04};

    button {
      opacity: 1;
    }
  }
`;

export const BoldText = styled.span`
  font-weight: ${theme.fontWeights.medium};
`;
